{
  "label.tokenBudget": "TOKEN 預算",
  "label.deadRules": "冗餘規則",
  "label.structure": "結構分析",
  "label.actionPlan": "行動計畫",
  "label.fixSummary": "修復摘要",
  "label.systemPrompt": "系統提示",
  "label.rootFile": "根指令檔",
  "label.ruleFiles": "規則檔",
  "label.skillFiles": "技能檔",
  "label.subDirFiles": "子目錄檔",
  "label.mcpServers": "MCP 伺服器",
  "label.baselineTotal": "初始總量",
  "label.available": "可用",
  "label.redundantByConfig": "冗餘（已由配置強制執行）",
  "label.duplicates": "重複項目",
  "label.contradictions": "規則矛盾",
  "label.staleReferences": "過時參照",
  "label.refactoringOpportunities": "重構建議",
  "label.tool": "工具：",
  "label.score": "分數：",

  "status.noBudgetIssues": "✓ 無 Token 預算問題",
  "status.noDeadRules": "✓ 無冗餘規則",
  "status.noStructuralIssues": "✓ 無結構性問題",
  "status.noAutoFixable": "✓ 無可自動修復的問題",
  "status.perfectScore": "✓ 滿分 — 無任何問題",
  "status.fixedIssues": "✓ 已修復 {{count}} 個問題 — 執行 `git diff` 查看變更",

  "error.unknownTool": "找不到代理指令檔。請在使用 Claude Code、Codex 或 Cursor 的專案中執行此指令。",
  "error.missingRootFile": "找到 {{tool}} 配置，但找不到根指令檔。",
  "error.dirtyWorkingTree": "工作目錄有未提交的變更。請先提交或儲藏變更再執行 --fix，或使用 --force 跳過此檢查。",

  "fix.removedDeadRules": "已移除 {{count}} 個冗餘規則",
  "fix.removedStaleRefs": "已移除 {{count}} 個過時參照",
  "fix.removedDuplicates": "已移除 {{count}} 個重複項目",

  "summary.redundantRules": "{{count}} 個冗餘規則",
  "summary.duplicates": "{{count}} 個重複項目",
  "summary.contradictions": "{{count}} 個規則矛盾",
  "summary.staleRefs": "{{count}} 個過時參照",
  "summary.refactoringSuggestions": "{{count}} 個重構建議",
  "summary.found": "發現 {{parts}}",

  "tokens.measured": "{{count}} tokens",
  "tokens.estimated": "~{{count}} tokens（估計值）",

  "actionPlan.andMore": "… 還有 {{count}} 個",

  "severity.critical": "{{count}} 個嚴重問題",
  "severity.warnings": "{{count}} 個警告",
  "severity.suggestions": "{{count}} 個建議",

  "budget.rootFileCritical": "根指令檔有 {{lines}} 行 — 超過 200 行後代理遵循率顯著下降",
  "budget.rootFileWarning": "根指令檔有 {{lines}} 行（建議：< 200 行）",
  "budget.mcpLargeServer": "MCP 伺服器「{{name}}」消耗約 {{tokens}} tokens",
  "budget.baselineHigh": "基線情境消耗佔視窗 {{pct}}%",

  "deadRule.configOverlap": "規則「{{rule}}」已由 {{config}} 強制執行",
  "deadRule.exactDuplicate": "與 {{otherFile}} 第 {{otherLine}} 行完全重複",
  "deadRule.nearDuplicate": "與 {{otherFile}} 第 {{otherLine}} 行高度相似（{{similarity}}% 相似度）",

  "structure.contradiction": "規則矛盾：「{{snippet}}」（{{fileA}} 第 {{lineA}} 行）與第 {{lineB}} 行衝突。",
  "structure.staleRef": "過時參照：「{{path}}」不存在。",
  "structure.scopeHook": "第 {{line}} 行的規則適合做成 git hook：「{{snippet}}」",
  "structure.scopePathScoped": "第 {{line}} 行的規則參照了特定路徑 — 建議建立路徑範圍的規則檔：「{{snippet}}」",

  "label.budget": "預算",
  "label.findings": "問題總覽",
  "label.topIssues": "首要問題",
  "label.category": "Category",

  "compact.budgetLine": "{{used}} / {{window}} tokens ({{pct}}%)",
  "compact.andMore": "… 還有 {{count}} 個（執行 instrlint <command> 查看詳情）",
  "compact.budget": "Budget",
  "compact.deadRules": "Dead rules",
  "compact.duplicates": "Duplicates",
  "compact.contradictions": "Contradictions",
  "compact.staleRefs": "Stale refs",
  "compact.structure": "Structure",

  "markdown.title": "instrlint 健康報告 — {{project}}",
  "markdown.scoreLine": "**分數：{{score}}/100 ({{grade}})** · 工具：`{{tool}}`",
  "markdown.summary": "## 摘要",
  "markdown.severity": "嚴重程度",
  "markdown.count": "數量",
  "markdown.critical": "🔴 嚴重",
  "markdown.warning": "🟡 警告",
  "markdown.info": "ℹ️ 資訊",
  "markdown.contradictions": "規則矛盾",
  "markdown.staleReferences": "過時參照",
  "markdown.deadRules": "冗餘規則",
  "markdown.duplicateRules": "重複項目",
  "markdown.budgetIssues": "Token 預算問題",
  "markdown.refactoringOpportunities": "重構建議",
  "markdown.lineRef": "（第 {{line}} 行）",
  "markdown.budgetCategory": "類別",
  "markdown.budgetTokens": "Token 數",
  "markdown.actionPlan": "## 行動計畫",
  "markdown.attribution": "*由 [instrlint](https://github.com/jed1978/instrlint) 生成*",

  "ci.passed": "✓ instrlint 通過  分數={{score}} 等級={{grade}}",
  "ci.failed": "✖ instrlint 未通過  分數={{score}} 等級={{grade}}",
  "ci.writtenTo": "→ 已寫入 {{file}}",

  "initCi.created": "✓ 已建立 {{path}}",
  "initCi.alreadyExists": "{{path}} 已存在。使用 --force 覆蓋。",

  "install.installed": "✓ 已安裝至 {{path}}\n  → 重新啟動 Claude Code 後即可使用 /instrlint",
  "install.alreadyExists": "{{path}} 已存在。使用 --force 覆蓋。",
  "install.unknownTarget": "請指定 --claude-code 或 --codex",
  "install.outdatedTitle": "instrlint skill 版本過舊",
  "install.outdatedVersions": "已安裝：{{installed}} → 最新：{{current}}",
  "install.updateCmd": "npx instrlint install {{flag}} --force",
  "install.updatePrompt": "是否立即更新？",

  "verification.confirmed": "LLM 已確認",
  "verification.uncertain": "LLM 不確定",
  "verification.filteredCount": "⊘ 已過濾 {{count}} 個{{s}} false positive（由 LLM 判斷）",

  "fix.manualActions": "需要手動操作",
  "fix.hookCreate": "加入 .claude/settings.json：",
  "fix.hookWarning": "⚠ Hook 會執行 shell command，請仔細確認後再加入",
  "fix.pathScopedCreate": "建立 {{path}}：",
  "fix.thenRemoveLine": "搬移後請從 {{file}} 第 {{line}} 行刪除原規則"
}
